<template>
  <picker-field :label="label" :value="value" :is-focus="isFocus" :isNeedInput="isNeedInput" title="选择供应商" @onchange="onchange" ref="picker" @open="onSearch">
    <template v-slot:tbar>
      <search-bar
        @search="onSearch"
        @focus="onFocusChange"
        name="ve_code,ve_name"
        placeholder="输入供应商编号、名称进行查找"
        ref="searchBar"
      />
    </template>
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        @click="select(item)"
      >
        <div class="weui-cell__bd">
          <p>
            {{item.ve_name}}
            <span class="list-item-status" v-if="item.ve_type">{{item.ve_type}}</span>
          </p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.ve_code}}</p>
        </div>
      </div>
    </scroll-list>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import querylist from "@/mixins/querylist.js";

export default {
  components: {
    PickerField,
    SearchBar,
    ScrollList
  },
  mixins: [querylist],
  props: {
    label: {
      type: String,
      default: "供应商"
    },
    value: String,
    isNeedInput: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isFocus: false,
      listUrl: "/api/document/vendor/list",
      defaultCondition: [
        {
          field: "ve_statuscode",
          operation: "=",
          value: "ENABLE"
        },
        {
          field: "ve_audit_status_code",
          operation: "=",
          value: "AUDITED"
        },
      ]
    };
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.ve_name);
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onchange(value) {
      var me = this
      me.$emit("onchange", value);
    },
    onFocusChange(focus) {
      this.isFocus = focus;
    }
  }
};
</script>